// extracted by mini-css-extract-plugin
export default {"sso":"SSO_sso__9xsIo"};